function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-52a27f89\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/home/mlopes/Documentos/repos/app/letsbank/investor-legacy-dashboard-client/node_modules/bourbon/core\",\"/home/mlopes/Documentos/repos/app/letsbank/investor-legacy-dashboard-client/node_modules/bourbon-neat/core\"],\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LandingPageInvista.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-52a27f89\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/home/mlopes/Documentos/repos/app/letsbank/investor-legacy-dashboard-client/node_modules/bourbon/core\",\"/home/mlopes/Documentos/repos/app/letsbank/investor-legacy-dashboard-client/node_modules/bourbon-neat/core\"],\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./LandingPageInvista.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LandingPageInvista.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LandingPageInvista.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-52a27f89\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LandingPageInvista.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a27f89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/LandingPageInvista.vue
// module id = Cd2i
// module chunks = 0